import { useCallback, useState } from 'react';

export type BlockRefsType = {
  ref: React.RefObject<Element>;
  id?: string | undefined;
  parentId?: string | undefined;
};

export const useUpdateBlockRefs = () => {
  const [blockRefs, setBlockRefs] = useState<BlockRefsType[]>([]);

  const updateBlockRefs = useCallback((element: BlockRefsType) => {
    setBlockRefs((prev: BlockRefsType[]) => {
      const existingBlock = prev.findIndex((block) => block.id === element.id);
      if (existingBlock < 0) {
        return [...prev, element];
      } else {
        return prev.map((item) => {
          if (item.id === element.id) {
            return element;
          } else return item;
        });
      }
    });
  }, []);

  return { updateBlockRefs, blockRefs };
};
